<template>

    <b-modal id="bv-new-api-key" size="lg" hide-footer>
      <template #modal-title>MailerLite API token</template>

      <div class="row">
        <div class="col">
            <textarea
                class="form-control shadow-none inputbox" 
                placeholder="Paste API token here ..."
                rows="5"
                v-model="content"></textarea>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
                  <div>
    <button v-if="updating" type="button" class="btn btn-success submit col">
    <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button v-else type="button" class="btn btn-danger submit col" @click="sendMessage">Test</button>
      </div>
        </div>
      </div>

    </b-modal>

</template> 

<script>
export default {

  data() {
    return {
      updating: false,
      content: null,
    };
  },

  methods: {

    clearContent() {
      this.content = null;
    },

    hideNewMessageModal() {
      this.$bvModal.hide('bv-new-api-key');
    },

    sendMessage() {

        if (this.content == null || this.content == '') {this.sweetfire('Please enter API token')}

            else {

                this.$emit('set-api-key', this.content);
                this.hideNewMessageModal();

            };

        },

      

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: { title: "popup-title" },
        })

        },

    },

};
</script>

<style scoped>
.btn {border-radius:5px !important;}
</style>